import 'element-closest';
import Vue from 'vue';
import DomPortal from 'vue-dom-portal';
import axios from 'axios';
import qs from 'qs';
// import 'element-ui/lib/element-ui.common';
import currencyFilter from './currency-filter/currency-filter';
import eventBus from './event-bus/event-bus';
import modalEventBus from './event-bus/modal-event-bus';
import before from './before-directive/before-directive';
// import zeroFillFilter from './zero-fill-filter/zero-fill-filter';
// import dateFilter from './date-filter/date-filter';
// import tooltip from '../components/tooltip/Tooltip.vue';
import 'vuex';
axios.defaults.paramsSerializer = params => {
	return qs.stringify(params, { arrayFormat: 'repeat' });
};
// import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
import Vuelidate from 'vuelidate';
// import VueGtm from 'vue-gtm';
// import vMediaQuery from 'v-media-query/dist/v-media-query';
// import {MediaQueries} from 'vue-media-queries';
// import {mediaQueries} from './media-query/media-query';

import VueCookie from 'vue-cookie';
// import 'core-js/fn/array/from';
import contrastSwitch from '../components/contrast-switch/contrast-switch.vue';
import VueCallRequestModalGlue from '@ui-common/vue-call-request-modal-glue';

Vue.use(VueScrollTo);
Vue.prototype.$modalEventBus = modalEventBus;
Vue.prototype.openModal = (e, modalId, options) => {
	eventBus.$emit('openModal', e, modalId, options);
};
Vue.prototype.closeModal = (modalId, options) => {
	eventBus.$emit('closeModal', modalId, options);
};
// Vue.prototype.openOrsi = (orsiFeature) => {
// 	eventBus.$emit('openOrsi', orsiFeature);
// };
// Vue.use(VueGtm, {
// 	// debug: true
// });

Vue.directive('before', before);
Vue.use(DomPortal);

Vue.use(VueCookie);
// const mediaQueries = new MediaQueries();
// Vue.use(mediaQueries);
// Vue.use(vMediaQuery);
// const id = 'UA-34239713-1';
axios.defaults.headers.common['Cache-Control'] = 'no-store';
axios.defaults.headers.common.Pragma = 'no-cache';
axios.defaults.headers.common.Expires = 0;
Vue.prototype.$http = axios;
Vue.use(Vuelidate);
Vue.component('contrast-switch', contrastSwitch);
Vue.component('vue-call-request-modal-glue', VueCallRequestModalGlue);
Vue.filter('currency', currencyFilter);
// Vue.filter('date', dateFilter);
// Vue.filter('zero', zeroFillFilter);
// Vue.component('tooltip', tooltip);
Vue.config.ignoredElements = [
	'picture',
	/^call-request-/
];
